import {
    TransactionColumn,
    TransactionView,
} from "@common/types/views/transactionViews";
import { ViewType } from "@common/types/views/views";

export function createRuleTransactionsPreviewView({
    isSplitRule,
    isAccountingRule,
    isShowingApplied,
}: {
    isSplitRule: boolean;
    isAccountingRule: boolean;
    isShowingApplied: boolean;
}): TransactionView {
    const columns: TransactionView["columns"] = [
        {
            id: TransactionColumn.LOCK,
            options: { pin: "left" },
        },
        {
            id: TransactionColumn.DATE,
            options: { pin: "left" },
        },
        { id: TransactionColumn.DESCRIPTION },
        { id: TransactionColumn.CATEGORY },
        ...(isSplitRule
            ? [
                  {
                      id: TransactionColumn.SPLIT as const,
                      options: { pin: "left" as const },
                  },
                  {
                      id: TransactionColumn.COUNTERPARTY as const,
                  },
                  {
                      id: TransactionColumn.CLASSES as const,
                  },
              ]
            : []),

        ...(isAccountingRule
            ? [{ id: TransactionColumn.LEDGER as const }]
            : []),
        {
            id: TransactionColumn.AMOUNT,
            options: { pin: "right" },
        },
        {
            id: TransactionColumn.ENTITY,
            options: { pin: "right", minSize: 82 },
        },
    ];

    return {
        type: ViewType.TRANSACTION,
        columns,
        filters: {},
        options: {
            bulkActions: !isShowingApplied,
            selection: !isShowingApplied,
            readonly: true,
        },
    };
}
